import React from 'react';
import { IMyInfo } from '@/services/user/types';
import '@/styles/globals.scss';

import { Toaster } from '@/components/ui/sonner';
import { CustomSidebar } from '@/components/CustomSidebar';
import { SidebarProvider } from '@/components/ui/sidebar';
import { CustomNavbar } from '@/components/CustomNavbar';

export const SidebarLayout = ({
  children,
  myInfo,
}: {
  children: React.ReactNode;
  myInfo: IMyInfo;
}) => {
  return (
    <SidebarProvider>
      <CustomSidebar myInfo={myInfo} />
      <div className="grow transition-[margin]">
        <CustomNavbar myInfo={myInfo} />
        <div className="content p-4 has-[.module-template]:p-0">
          {children}
          <Toaster />
        </div>
      </div>
    </SidebarProvider>
  );
};

export default SidebarLayout;
